import {
    Button,
    Modal,
    Option,
    Select,
    selectClasses,
    Switch,
  } from "@mui/joy";
  import { WHITE } from "../../../../../appConstants";
  import React, {
    Dispatch,
    SetStateAction,
    useEffect,
    useState,
  } from "react";
  import CalenderIcon from "../../../../../svg/Ads_Dashboard_Developement2/CalenderIcon/elements.svg";
import CompareTwoDateRangeComponent from "../../../ComparisonDateRangeComponent/CompareTwoDateRangeComponent 1";
import DragAndDropIcon from "../../../../../svg/Ads_Dashboard_Developement2/Drag_and_Drop_Icon/elements.svg";
import toast from "react-hot-toast";

  type Parameter = {
    id: number;
    parameter_name: string;
    backend_parameter_name: string;
    toggle: boolean;
    position: number;
  };
  type Matrice = {
    id: number;
    matrice_name: string;
    backend_matrice_name: string;
    toggle: boolean;
    position: number;
  };
  type DateProps = {
    startDate: Date;
    endDate: Date;
  };
  type Range = {
    rangeOne: DateProps;
    rangeTwo: DateProps;
  };
  type IpDate = {
    rangeOne: DateProps;
    rangeTwo: DateProps;
  };
  type RangeProps = {
    min_date: Date;
    max_date: Date;
  };
  type ComparisonCustomExportModalProps = {
    setToggle: Dispatch<SetStateAction<boolean>>;
    ip_maxminRange: RangeProps;
    ip_Range: Range;
    parametersData: Parameter[];
    matricesData: Matrice[];
    exportfunc : (ip_Range: Range, transposeFormat: string, parameters: string[], matrices: string[]) => void;
    ip_transposeFormat: string,
    loading: boolean;
  };
  
  const OverviewComparisonCustomExportModal: React.FC<ComparisonCustomExportModalProps> = ({
    setToggle,
    ip_maxminRange,
    ip_Range,
    parametersData,
    matricesData,
    exportfunc,
    ip_transposeFormat,
    loading
  }) => {
    const [inputRange, setInputRange] = useState<Range>({} as Range);    
    const [range, setRange] = useState<RangeProps>({} as RangeProps);
    const [transposeFormat, setTransposeFormat] = useState<string>("");
    const [initial_parameters, setInitial_parameters] = useState<Parameter[]>([]);
    const [initial_matrices, setInitial_matrices] = useState<Matrice[]>([]);
    const [dateToggle, setDateToggle] = useState<boolean>(false);

    const apply = (date: IpDate) => {
        setInputRange((prev) => ({
        ...prev,
        rangeOne: date?.rangeOne,
        }));
        setInputRange((prev) => ({
        ...prev,
        rangeTwo: date?.rangeTwo,
        }));
    };

    // For Parameter
    const ParameterSwitchChangeHandler = (parameter_id: Number) => {
        const Exist = initial_parameters.find(
            (d: Parameter) => d?.id === parameter_id
        )?.toggle;
        let newParameterArr = [] as Parameter[];
        if (Exist) {
            if (initial_parameters.filter((item) => item.toggle).length === 1) {
            toast.error("Minimum 1 Parameter to be present");
            return;
            } else if (initial_parameters.filter((item) => item.toggle).length > 1) {
            newParameterArr = initial_parameters.map((d) =>
                d.id === parameter_id ? { ...d, toggle: false } : d
            );
            }
        } else {
            newParameterArr = initial_parameters.map((d) =>
            d.id === parameter_id ? { ...d, toggle: true } : d
            );
        }
        setInitial_parameters(newParameterArr);
        // updateColumns([], "PARAMETER", newParameterArr, [], true);
    };

    // For Metricess
    const MatriceSwitchChangeHandler = (matrice_id: Number) => {
        const Exist = initial_matrices.find(
            (d: Matrice) => d?.id === matrice_id
        )?.toggle;
        let newMatricesArr = [] as Matrice[];
        if (Exist) {
            if (initial_matrices.filter((item) => item.toggle).length === 1) {
                toast.error("Minimum 1 Matrice to be present");
                return;
            } else if (initial_matrices.filter((item) => item.toggle).length > 1) {
                newMatricesArr = initial_matrices.map((d) =>
                    d.id === matrice_id ? { ...d, toggle: false } : d
                );
            }
        } else {
            newMatricesArr = initial_matrices.map((d) =>
            d.id === matrice_id ? { ...d, toggle: true } : d
            );
        }
        setInitial_matrices(newMatricesArr);
        // updateColumns([], "METRICE", [], newMatricesArr, true);
    };

    // For Parameter
    const [draggedParameter, setDraggedParameter] = useState<Parameter | null>(
        null
    );

    const parameterDragStarthandle = (item: Parameter) => {
        setDraggedParameter(item);
    };

    const parameterDragOverhandle = (event: React.DragEvent<HTMLDivElement>) => {
        event.preventDefault();
    };

    const parameterhandleDrop = (targetItem: Parameter) => {
        if (!draggedParameter || draggedParameter.id === targetItem.id) return;
    
        const draggedIndex = initial_parameters.findIndex(
        (item) => item?.id === draggedParameter.id
        );
        const targetIndex = initial_parameters.findIndex(
        (item) => item?.id === targetItem.id
        );
    
        if (draggedIndex === -1 || targetIndex === -1) return;
    
        // Clone the array to avoid mutating state directly
        const updatedMatricesData = [...initial_parameters];
    
        // Remove the dragged item
        const [draggedMatrice] = updatedMatricesData.splice(draggedIndex, 1);
    
        // Insert it at the target index
        updatedMatricesData.splice(targetIndex, 0, draggedMatrice);
    
        // Reassign position field based on new order
        const reorderedMatricesData = updatedMatricesData.map((item, index) => ({
        ...item,
        position: index,
        }));
        setInitial_parameters(reorderedMatricesData);
    };

    // For Metrice
    const [draggedMetrice, setDraggedMetrice] = useState<Matrice | null>(null);

    const metriceDragStarthandle = (item: Matrice) => {
        setDraggedMetrice(item);
    };

    const metriceDragOverhandle = (event: React.DragEvent<HTMLDivElement>) => {
        event.preventDefault();
    };

    const metricehandleDrop = (targetItem: Matrice) => {
        if (!draggedMetrice || draggedMetrice.id === targetItem.id) return;
    
        const draggedIndex = initial_matrices.findIndex(
        (item) => item?.id === draggedMetrice.id
        );
        const targetIndex = initial_matrices.findIndex(
        (item) => item?.id === targetItem.id
        );
    
        if (draggedIndex === -1 || targetIndex === -1) return;
    
        // Clone the array to avoid mutating state directly
        const updatedMatricesData = [...initial_matrices];
    
        // Remove the dragged item
        const [draggedMatrice] = updatedMatricesData.splice(draggedIndex, 1);
    
        // Insert it at the target index
        updatedMatricesData.splice(targetIndex, 0, draggedMatrice);
    
        // Reassign position field based on new order
        const reorderedMatricesData = updatedMatricesData.map((item, index) => ({
        ...item,
        position: index,
        }));
        setInitial_matrices(reorderedMatricesData);
        // }
    };
    
    const exportHandler = () => {
      let selected_parameters =  initial_parameters
        ?.filter((p) => p?.toggle === true)
        ?.map((p) => p.backend_parameter_name);

      let selected_matrics = initial_matrices
          .filter((d) => d?.toggle === true)
          .map((item) => item?.backend_matrice_name);
      exportfunc(inputRange, transposeFormat, selected_parameters, selected_matrics);
    }
    useEffect(() => {
        setTransposeFormat(ip_transposeFormat);
        setInitial_parameters(parametersData);
        setInitial_matrices(matricesData);
        setInputRange(ip_Range);
        setRange(ip_maxminRange);
    }, []);
  
    return (
      <Modal
        open={true}
        sx={{ display: "flex", justifyContent: "center", alignItems: "center" }}
        className="h-full"
      >
        <div className="relative">
          <div
            style={{
              width: 1200,
              height: 700,
              paddingLeft: 40,
              paddingRight: 40,
              paddingBottom: 40,
              paddingTop: 40,
              backgroundColor: `${WHITE.W_100}`,
            }}
            className="flex flex-col items-center justify-between rounded-[16px] gap-10"
          >
            <div className="flex justify-between gap-1 w-full">
                <div className="flex flex-col w-[60%]">
                    <div
                        className="self-stretch"
                        style={{
                        color: `#1C1C1E`,
                        fontSize: 20,
                        fontStyle: "normal",
                        fontWeight: 700,
                        lineHeight: "26px",
                        }}
                    >
                        Select Export Preferences
                    </div>
                    <div
                        className="self-stetch"
                        style={{
                        color: `#97979A`,
                        fontSize: 14,
                        fontStyle: "normal",
                        fontWeight: 500,
                        lineHeight: "22px",
                        }}
                    >
                        Export the table or customise with specific Product Details, Parameters, Metrics 
                    </div>
                </div>

                <div className="flex flex-col items-end gap-2">
                  <div
                      className="flex h-fit items-center py-2 px-4 gap-2 rounded-[4px]"
                      style={{
                      border: "1px solid #EAEAED",
                      position: "relative",
                      }}
                  >
                      <div className="flex items-center gap-2">
                          <div
                          style={{
                              color: "var(--Text-Primary-Black, #1C1C1E)",
                              fontFamily: "Inter",
                              fontSize: "10px",
                              fontStyle: "normal",
                              fontWeight: 500,
                              lineHeight: "14px",
                              textWrap: 'nowrap'
                          }}
                          >
                          {`${String(inputRange?.rangeOne?.startDate?.getDate()).padStart(
                              2,
                              "0"
                          )}/${String(
                              inputRange?.rangeOne?.startDate?.getMonth() + 1
                          ).padStart(
                              2,
                              "0"
                          )}/${inputRange?.rangeOne?.startDate?.getFullYear()} - ${String(
                              inputRange?.rangeOne?.endDate?.getDate()
                          ).padStart(2, "0")}/${String(
                              inputRange?.rangeOne?.endDate?.getMonth() + 1
                          ).padStart(
                              2,
                              "0"
                          )}/${inputRange?.rangeOne?.endDate?.getFullYear()} `}
                          </div>
                          <div
                          style={{
                              color: "var(--Text-Primary-Grey, #97979A)",
                              fontFamily: "Inter",
                              fontSize: "8px",
                              fontStyle: "normal",
                              fontWeight: 400,
                              lineHeight: "12px",
                          }}
                          >
                          Vs
                          </div>
                          <div
                          style={{
                              color: "var(--Text-Primary-Black, #1C1C1E)",
                              fontFamily: "Inter",
                              fontSize: "10px",
                              fontStyle: "normal",
                              fontWeight: 500,
                              lineHeight: "14px",
                              textWrap: 'nowrap'
                          }}
                          >
                          {`${String(inputRange?.rangeTwo?.startDate?.getDate()).padStart(
                              2,
                              "0"
                          )}/${String(
                              inputRange?.rangeTwo?.startDate?.getMonth() + 1
                          ).padStart(
                              2,
                              "0"
                          )}/${inputRange?.rangeTwo?.startDate?.getFullYear()} - ${String(
                              inputRange?.rangeTwo?.endDate?.getDate()
                          ).padStart(2, "0")}/${String(
                              inputRange?.rangeTwo?.endDate?.getMonth() + 1
                          ).padStart(
                              2,
                              "0"
                          )}/${inputRange?.rangeTwo?.endDate?.getFullYear()} `}
                          </div>
                      </div>
                      <img
                      src={CalenderIcon}
                      alt="OverView Icon"
                      style={{ cursor: "pointer" }}
                      onClick={() => setDateToggle(true)}
                      />
                      {dateToggle && (
                      <div
                      className="absolute "
                      style={{ top: "37px", right: "0px", zIndex: 100 }}
                      >
                      <CompareTwoDateRangeComponent
                          rangeOne={{
                          startDate: inputRange?.rangeOne?.startDate,
                          endDate: inputRange?.rangeOne?.endDate,
                          }}
                          rangeTwo={{
                          startDate: inputRange?.rangeTwo?.startDate,
                          endDate: inputRange?.rangeTwo?.endDate,
                          }}
                          apply={apply}
                          minDate={range?.min_date}
                          maxDate={range?.max_date}
                          setDateToggle={setDateToggle}
                      />
                      </div>
                      )}
                  </div>
                  <div className="flex w-[150px] gap-1">
                    <Select
                      className="w-full"
                      onChange={(e: any, value: any) => {
                        setTransposeFormat(value);
                      }}
                      name="transpose"
                      value={transposeFormat}
                      indicator={
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="20"
                          height="20"
                          viewBox="0 0 20 20"
                          fill="none"
                        >
                          <path
                            d="M9.99984 12.4791C9.88873 12.4791 9.78456 12.4618 9.68734 12.4271C9.59012 12.3923 9.49984 12.3333 9.4165 12.25L5.58317 8.41665C5.43039 8.26387 5.354 8.06942 5.354 7.83331C5.354 7.5972 5.43039 7.40276 5.58317 7.24998C5.73595 7.0972 5.93039 7.02081 6.1665 7.02081C6.40262 7.02081 6.59706 7.0972 6.74984 7.24998L9.99984 10.5L13.2498 7.24998C13.4026 7.0972 13.5971 7.02081 13.8332 7.02081C14.0693 7.02081 14.2637 7.0972 14.4165 7.24998C14.5693 7.40276 14.6457 7.5972 14.6457 7.83331C14.6457 8.06942 14.5693 8.26387 14.4165 8.41665L10.5832 12.25C10.4998 12.3333 10.4096 12.3923 10.3123 12.4271C10.2151 12.4618 10.1109 12.4791 9.99984 12.4791Z"
                            fill="#1C1C1C"
                            fill-opacity="0.4"
                          />
                        </svg>
                      }
                      slotProps={{
                        listbox: {},
                      }}
                      sx={{
                        "--Input-focusedThickness": "0px",
                        height: "32px",
                        color: "#1C1C1E",
                        fontSize: 14,
                        fontWeight: 400,
                        lineHeight: "20px",
                        backgroundColor: WHITE.W_100,
                        boxShadow: "none",
                        border: `1px solid #EAEAED`,
                        [`& .${selectClasses.indicator}`]: {
                          transition: "0.2s",
                          [`&.${selectClasses.expanded}`]: {
                            transform: "rotate(-180deg)",
                          },
                        },
                        ":hover": {
                          backgroundColor: WHITE.W_100,
                        },
                      }}
                    >
                        <Option value={"VERTICAL"}>V-Comparison</Option>
                        <Option value={"HORIZONTAL"}>H-Comparison</Option>
                    </Select>
                  </div>
                </div>
            </div>

            <div className="w-full h-[430px] flex gap-10">
                {/* Parameters */}
                <div
                className="flex flex-col items-start h-fit gap-4 self-stretch rounded-[4px]"
                style={{
                  border: "1px solid #EAEAED",
                  flex: 1,
                  maxHeight: "430px",
                  height: "fit-content"
                }}
              >
                <div
                  className="flex items-start self-stretch rounded-[4px] cursor-pointer"
                  style={{
                    borderBottom: "1px solid #EAEAED",
                  }}
                //   onClick={() => {
                //     if (drawerSubOption === "PARAMETERS") {
                //       setDrawerSubOption("");
                //     } else {
                //       setDrawerSubOption("PARAMETERS");
                //     }
                //   }}
                >
                  <div className="flex h-[44px] w-full justify-between px-4 py-2 items-center gap-2 ">
                    <div
                      style={{
                        color: "var(--Text-Primary-Black, #1C1C1E)",
                        fontFamily: "Inter",
                        fontSize: "10px",
                        fontStyle: "normal",
                        fontWeight: 500,
                        lineHeight: "10px", // 100%
                        letterSpacing: "1.6px",
                        textTransform: "uppercase",
                      }}
                    >
                      Parameters
                    </div>
                    {/* {drawerSubOption === "PARAMETERS" ? (
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="20"
                        height="20"
                        viewBox="0 0 20 20"
                        fill="none"
                      >
                        <path
                          d="M6.83366 11.6667C6.70866 11.6667 6.60796 11.625 6.53158 11.5417C6.45519 11.4583 6.41699 11.3611 6.41699 11.25C6.41699 11.2222 6.45866 11.125 6.54199 10.9583L9.56283 7.9375C9.63227 7.86806 9.70171 7.81944 9.77116 7.79167C9.8406 7.76389 9.91699 7.75 10.0003 7.75C10.0837 7.75 10.16 7.76389 10.2295 7.79167C10.2989 7.81944 10.3684 7.86806 10.4378 7.9375L13.4587 10.9583C13.5003 11 13.5316 11.0451 13.5524 11.0938C13.5732 11.1424 13.5837 11.1944 13.5837 11.25C13.5837 11.3611 13.5455 11.4583 13.4691 11.5417C13.3927 11.625 13.292 11.6667 13.167 11.6667H6.83366Z"
                          fill="#1C1C1E"
                        />
                      </svg>
                    ) : (
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="20"
                        height="20"
                        viewBox="0 0 20 20"
                        fill="none"
                      >
                        <path
                          d="M9.56234 12.0625L6.5415 9.04167C6.49984 9 6.46859 8.95486 6.44775 8.90625C6.42692 8.85764 6.4165 8.80556 6.4165 8.75C6.4165 8.63889 6.4547 8.54167 6.53109 8.45834C6.60748 8.375 6.70817 8.33334 6.83317 8.33334H13.1665C13.2915 8.33334 13.3922 8.375 13.4686 8.45834C13.545 8.54167 13.5832 8.63889 13.5832 8.75C13.5832 8.77778 13.5415 8.875 13.4582 9.04167L10.4373 12.0625C10.3679 12.1319 10.2984 12.1806 10.229 12.2083C10.1596 12.2361 10.0832 12.25 9.99984 12.25C9.9165 12.25 9.84012 12.2361 9.77067 12.2083C9.70123 12.1806 9.63178 12.1319 9.56234 12.0625Z"
                          fill="#1C1C1E"
                        />
                      </svg>
                    )} */}
                  </div>
                </div>
                  <div className="flex flex-col items-start self-stretch" style={{
                    overflowY: 'auto',
                }}>
                    {initial_parameters?.length > 0 &&
                      initial_parameters?.map((p: Parameter) => (
                        <div
                          className="flex justify-between items-center h-[40px] p-4 gap-2 self-stretch"
                          key={p?.parameter_name}
                          draggable
                          onDragStart={() => parameterDragStarthandle(p)}
                          onDragOver={parameterDragOverhandle}
                          onDrop={() => parameterhandleDrop(p)}
                        >
                          <div className="flex items-center gap-1">
                            <img
                              src={DragAndDropIcon}
                              alt="Drag And Drop Icon"
                              style={{ cursor: "pointer" }}
                            />
                            <div
                              className=""
                              style={{
                                fontFamily: "Inter",
                                paddingLeft: "5px",
                                color: "#1C1C1E",
                                fontSize: "12px",
                                fontWeight: p?.toggle ? 600 : 400,
                                lineHeight: "18px",
                              }}
                            >
                              {p?.parameter_name}
                            </div>
                          </div>
                          <Switch
                            checked={p?.toggle}
                            onChange={(event) =>
                              ParameterSwitchChangeHandler(p?.id)
                            }
                          />
                        </div>
                      ))}
                  </div>
                </div>

                {/* Metrices */}
              <div
                className="flex flex-col items-start gap-4 self-stretch rounded-[4px]"
                style={{
                  border: "1px solid #EAEAED",
                  flex: 1,
                  maxHeight: "430px",
                  height: "fit-content"
                }}
              >
                <div
                  className="flex items-start self-stretch rounded-[4px] cursor-pointer"
                  style={{
                    borderBottom: "1px solid #EAEAED"
                  }}
                //   onClick={() => {
                //     if (drawerSubOption === "METRICES") {
                //       setDrawerSubOption("");
                //     } else {
                //       setDrawerSubOption("METRICES");
                //     }
                //   }}
                >
                  <div className="flex h-[44px] w-full justify-between px-4 py-2 items-center gap-2 ">
                    <div
                      style={{
                        color: "var(--Text-Primary-Black, #1C1C1E)",
                        fontFamily: "Inter",
                        fontSize: "10px",
                        fontStyle: "normal",
                        fontWeight: 500,
                        lineHeight: "10px", // 100%
                        letterSpacing: "1.6px",
                        textTransform: "uppercase",
                      }}
                    >
                      Metrics
                    </div>
                  </div>
                </div>
                <div className="flex flex-col items-start self-stretch" style={{
                    overflowY: 'auto',
                }}>
                    {initial_matrices.length > 0 &&
                    initial_matrices?.map((m: Matrice) => (
                        <div
                            className="flex justify-between items-center h-[40px] p-4 gap-2 self-stretch"
                            key={m?.matrice_name}
                            draggable
                            onDragStart={() => metriceDragStarthandle(m)}
                            onDragOver={metriceDragOverhandle}
                            onDrop={() => metricehandleDrop(m)}
                        >
                            <div className="flex items-center gap-1">
                            <img
                                src={DragAndDropIcon}
                                alt="Drag And Drop Icon"
                                style={{ cursor: "pointer" }}
                            />
                            <div
                                className=""
                                style={{
                                fontFamily: "Inter",
                                paddingLeft: "5px",
                                color: "#1C1C1E",
                                fontSize: "12px",
                                fontWeight: m?.toggle ? 600 : 400,
                                lineHeight: "18px",
                                }}
                            >
                                {m?.matrice_name}
                            </div>
                            </div>
                            <Switch
                            checked={m?.toggle}
                            onChange={(event) =>
                              MatriceSwitchChangeHandler(m?.id)
                            }
                            />
                        </div>
                    ))}
                </div>
              </div>
            </div>

            <div className="flex items-start justify-center gap-10 self-stretch">
              <Button
                color="neutral"
                sx={{
                  height: "40px",
                  width: "50%",
                  backgroundColor: "#FFF",
                  ":hover": {
                    backgroundColor: "#FFF",
                  },
                  color: "#1C1C1E",
                  borderRadius: "8px",
                  border: "1px solid #F2F2F5",
                  padding: "0px 8px",
                  fontSize: "14px",
                  fontWeight: 700,
                  lineHeight: "18px",
                }}
                onClick={() => setToggle(false)}
              >
                Cancel
              </Button>
              <Button
                onClick={exportHandler}
                sx={{
                  height: "40px",
                  width: "50%",
                  backgroundColor: "#1565C0",
                  color: "#FFF",
                  borderRadius: "8px",
                  padding: "0px 8px",
                  fontSize: "14px",
                  fontWeight: 700,
                  lineHeight: "18px",
                }}
                loading={loading}
              >
                Export
              </Button>
            </div>
          </div>
        </div>
      </Modal>
    );
  };
  
  export default OverviewComparisonCustomExportModal;
  